import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth-guard';
import { FarmAppGuard } from './farm-app-guard';
import { MainComponent } from './shared/components/main/main.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { SupplyDemandGuard } from './supply-demand-guard';
import { WarehouseGuard } from './warehouse-guard';
import { LabShipmentComponent } from './shared/components/lab-shipment/lab-shipment.component';
import { LabCartComponent } from './shared/components/lab-cart/lab-cart.component';
import { LabSampleComponent } from './shared/components/lab-sample/lab-sample.component';
import { LabAppGuard } from './lab-app-guard';

const routes: Routes = [
  { path: 'auth', loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)},
  { path:'labshipment',component:LabShipmentComponent,canActivate:[AuthGuard]},
  { path:'labcart',component:LabCartComponent,canActivate:[AuthGuard]},
  { path:'labsample',component:LabSampleComponent,canActivate:[AuthGuard]},
  { path:'', component:MainComponent,
  canActivate:[AuthGuard],
  children: [
    {
      path:'',
      redirectTo:'summary-dashboard',
      pathMatch:'full'
      // loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
    },
    {
      path:'farm',canActivate:[FarmAppGuard],
      loadChildren: () => import('./modules/farm-app/farm-app.module').then(m => m.FarmAppModule),
    },
    {
      path:'warehouse',canActivate:[WarehouseGuard],
      loadChildren: () => import('./modules/warehouse/warehouse.module').then(m => m.WarehouseModule)
    },
    {
      path:'supply',canActivate:[SupplyDemandGuard],
      loadChildren: () => import('./modules/supply-demand/supply-demand.module').then(m => m.SupplyDemandModule)
    },
    {
      path:'lab',canActivate:[LabAppGuard],
      loadChildren: () => import('./modules/lab/lab.module').then(m => m.LabModule)
    },
    {
      path:'summary-dashboard',
      loadChildren: () => import('./modules/summary-dashboard/summary-dashboard.module').then(m => m.SummaryDashboardModule),
    },
    { 
      path: 'quality-check', 
      loadChildren: () => import('./modules/quality-check/quality-check.module').then(m => m.QualityCheckModule) , canActivate: [AuthGuard]
    }, 
    { 
      path: 'hse', 
      loadChildren: () => import('./modules/hse/hse.module').then(m => m.HseModule) 
    },
  ]
},
  {path: '404', component: PageNotFoundComponent},
  {path: '**', redirectTo: '/404'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
